'use strict';

module.exports = [function tableLoadMore () {
    return {
        replace: true,
        scope: true,        
        template: require('./tableLoadMore.html')
    };
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableLoadMore.js
// module id = 368
// module chunks = 0